import React from "react";
import "./OrderInfo.scss";
import Sidebar from "../Sidebar/Sidebar";
import { Link } from "react-router-dom";
import axios from "axios";
import * as backendModule from "../../modules/backendModule";
import Spinner from "../Spinner";
import moment from "moment";
import { useSearchParams } from "react-router-dom";

const OrderInfo = () => {

    const [searchParams] = useSearchParams();
    const [order, setOrder] = React.useState(null);
    const [spinner, setSpinner] = React.useState(true);
    const [btnSpinner, setBtnSpinner] = React.useState(false);
    const [deleteSpinner, setDeleteSpinner] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [products, setProducts] = React.useState([]);

    const orderId = searchParams.get("orderId");

    const getOrder = () => {
        setSpinner(true);
        axios({
            method: "POST",
            url: `${backendModule.backendURL}/orders/getOrderByID`,
            data: {
                ID: orderId
            },
            ...backendModule.axiosConfig,
        }).then(res => {
            if (res.data.status === "ok") {
                setOrder(res.data?.data);
            } else {
                setError('Došlo je do serverske greške');
            }
        }).catch(() => {
            setError('Došlo je do serverske greške');
        }).finally(() => {
            setSpinner(false);
        });
    }

    const changeStatus = (status) => {
        setBtnSpinner(true);
        axios({
            method: "POST",
            url: `${backendModule.backendURL}/orders/editStatus`,
            data: {
                ID: orderId,
                Status: status
            },
            ...backendModule.axiosConfig,
        }).then(res => {
            if (res.data.status === "ok") {
                getOrder();
            } else {
                setError('Došlo je do serverske greške');
            }
        }).catch(() => {
            setError('Došlo je do serverske greške');
        }).finally(() => {
            setBtnSpinner(false);
        });
    }

    const deleteOrder = () => {
        setBtnSpinner(true);
        axios({
            method: "POST",
            url: `${backendModule.backendURL}/orders/removeOrder`,
            data: {
                ID: orderId,
            },
            ...backendModule.axiosConfig,
        }).then(res => {
            if (res.data.status === "ok") {
                window.location.href = "/admin/orders";
            } else {
                setError('Došlo je do serverske greške');
            }
        }).catch(() => {
            setError('Došlo je do serverske greške');
        }).finally(() => {
            setBtnSpinner(false);
        });
    }

    React.useEffect(() => {
        getOrder();
    }, [orderId]);

    React.useEffect(() => {
        if (order?.Products) {
            setProducts(JSON.parse(order?.Products));
        }
    }, [order]);

    return (
        <div className="orderDetails">
            <Sidebar />
            {!error && !spinner ? <div className="orderDetails__container">
                <div className="orderDetails__header">
                    <div className="orderDetails__header__left">
                        <h1>Detalji narudžbe</h1>
                        <span>Jedinstveni broj narudžbe: {order.ID}</span>
                    </div>
                    {!btnSpinner && <button onClick={() => changeStatus(order?.Status == 0 ? 1 : order?.Status == 1 ? 2 : 0)}>{order?.Status == 0 ? 'Označi kao poslano' : order?.Status == 1 ? 'Označi kao isporučeno' : 'Vrati na čekanje'}</button>}
                    {btnSpinner && <div className="orderDetails__header__spindiv"><Spinner color="whitesmoke" style={{ width: '24px', height: '24px', marginLeft: 'auto', marginRight: 'auto', display: 'block' }} /></div>}
                </div>

                <div className="orderDetails__content">

                    <div className="orderDetails__card">
                        <h2>Informacije o kupcu</h2>

                        <div className="orderDetails__info">
                            <p>
                                <strong>Ime:</strong> {order.FirstName}
                            </p>

                            <p>
                                <strong>Prezime:</strong> {order.LastName}
                            </p>

                            <p>
                                <strong>Telefon:</strong> {order.Phone}
                            </p>

                            <p>
                                <strong>Država:</strong> {order.Country}
                            </p>

                            <p>
                                <strong>Grad:</strong> {order.City}
                            </p>

                            <p>
                                <strong>Ulica:</strong> {order.Street}
                            </p>

                            <p>
                                <strong>Poštanski broj:</strong> {order.Postcode}
                            </p>
                        </div>
                    </div>

                    <div className="orderDetails__card">
                        <h2>Informacije o narudžbi</h2>

                        <div className="orderDetails__info">
                            <p>
                                <strong>Datum:</strong> {moment(order.createdAt).format('D.M.YYYY.')}
                            </p>

                            <p>
                                <strong>Način plaćanja:</strong> {order.PaymentMethod}
                            </p>

                            <p>
                                <strong>Ukupna cijena:</strong> {order.TotalPrice} KM
                            </p>

                            <p>
                                <strong>Poštarina:</strong> {order.ShippingPrice} KM
                            </p>

                            <p>
                                <strong>Status:</strong> {order.Status == 0 ? 'Na čekanju' : order.Status == '1' ? 'Poslano' : 'Isporučeno'}
                            </p>

                            <p>
                                <strong>Napomena:</strong> {order.Notes}
                            </p>
                        </div>
                    </div>

                    <div className="orderDetails__card">
                        <h2>Proizvodi</h2>

                        <div className="orderDetails__products">
                            {products.length > 0 ? products.map((product) => (
                                <div
                                    className="orderDetails__product"
                                    key={product.ProductID}
                                >
                                    <img
                                        src={`${backendModule.backendURL}/${product.ImagePath}`}
                                        alt={product.ProductName}
                                    />

                                    <div className="orderDetails__productInfo">
                                        <h3>{product.ProductName}</h3>

                                        <p>
                                            ID proizvoda: {product.ProductID}
                                        </p>

                                        <p>
                                            Količina: {product.Quantity}
                                        </p>
                                    </div>
                                </div>
                            )) : null}
                        </div>
                    </div>

                    <div onClick={() => deleteOrder()} className="orderDetails__deleteBtn">
                        {!btnSpinner && <p>Obriši narudžbu</p>}
                        {btnSpinner && <Spinner color="whitesmoke" style={{ width: '24px', height: '24px', marginLeft: 'auto', marginRight: 'auto', display: 'block' }} />}
                    </div>

                </div>
            </div> : null}
            {error && <p>{error}</p>}
            {spinner && <Spinner style={{ width: '64px', height: '50px', color: 'black' }} color="black" />}
        </div>
    );
};

export default OrderInfo;
